import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ReportsBasePage } from '../reportsBase/reportsBase.page';
import { MyTimestampPipe } from '@shared/pipes';
// import { ViewBasePage } from '@shared/pages';
// import { Constants } from '@shared/models';
import type { TResponse, TTimestamp } from '@shared/models';

@Component({
    'selector': 'app-report2Parameters',
    'templateUrl': './report2Parameters.page.html',
    'styleUrls': ['./report2Parameters.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule, MyTimestampPipe]
})
export class Report2ParametersPage extends ReportsBasePage implements OnInit {
    // public vm: any = {};
    public dateRangeStart: TTimestamp;
    public dateRangeEnd: TTimestamp;
    public selectedStartDate: TTimestamp;
    public selectedEndDate: TTimestamp;

    constructor( injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_REPORTS_PAGE2);
    }

    public override ngOnInit(): void {
        this.vm = super.getViewModel();

        // Supply starting and ending date default values.
        const accountProfile = this.sessionService.getAccountProfile();

        this.dateRangeStart = accountProfile.signupDate;
        this.dateRangeEnd = this.dateService.now();
        this.selectedStartDate = this.dateRangeStart;
        this.selectedEndDate = this.dateRangeEnd;

        this.dateRangeStart = accountProfile.signupDate;
        this.dateService.setHoursMinutesSeconds(this.dateRangeStart, 0, 0, 0);

        this.dateRangeEnd = this.dateService.now();
        this.dateService.setHoursMinutesSeconds(this.dateRangeStart, 23, 59, 59);

        this.selectedStartDate = this.dateRangeStart;
        this.selectedEndDate = this.dateRangeEnd;

        // this.initMoreMenu();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-reports-2-tour');
    // }

    public async onStartingReportDateClick(): Promise<void> {
        const response: any = await this.openCalendarModal(
            this.dateRangeStart, this.dateRangeEnd, this.selectedStartDate, 'Select Starting Date');

        if (response.data.okay) {
            this.selectedStartDate = this.dateService.toTimestamp(response.data.selectedItems[0]);
        }
    }

    public async onEndingReportDateClick() {
        const response: any = await this.openCalendarModal(
            this.dateRangeStart, this.dateRangeEnd, this.selectedEndDate, 'Select Ending Date');

        if (response.data.okay) {
            this.selectedEndDate = this.dateService.toTimestamp(response.data.selectedItems[0]);
        }
    }

    private verifyDateRange(): boolean {
        if (this.selectedStartDate.seconds > this.selectedEndDate.seconds) {
            this.uxHelperService.showAlert('Error', 'Starting Date must be before Ending Date.');
            return false;
        }

        return true;
    }

    public onNextClick() {
        if (!this.verifyDateRange()) {
            return;
        }

        // Start date begins at 12:00:00am and endDate ends at 11:59:59pm
        // let date = this.dateService.parse(this.startingDate, DateTimeFormats.BigDate);
        this.vm.mmStartingDate = this.dateService.setHoursMinutesSeconds(this.selectedStartDate, 0, 0, 0);

        // date = this.dateService.parse(this.endingDate, DateTimeFormats.BigDate);
        this.vm.mmEndingDate = this.dateService.setHoursMinutesSeconds(this.selectedEndDate, 23, 59, 59);

        this.vm.isDebugMode = this.sessionService.isDebugMode();

        super.setViewModel(this.vm);
        this.router.navigateByUrl('/reports/report3View');
    }
}
